export default __webpack_public_path__ + "static/media/season4_winner.02af7a8d.png";